"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrossIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const constants_1 = require("../constants");
/**
 * Standard cross icon
 * See:https://www.figma.com/file/qPpy550VSNWIx9tBNcZJrG/SDS-WebC-Icons?node-id=1276%3A1
 */
function CrossIcon(props) {
    const { className, "data-testid": dataTestId, fill = "#000000", size = constants_1.Sizes.Large } = props;
    return ((0, jsx_runtime_1.jsxs)("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: fill, xmlns: "http://www.w3.org/2000/svg", className: className, "data-testid": dataTestId, children: [(0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.3931 19.8023L4.19312 5.61234L5.60683 4.19763L19.8068 18.3876L18.3931 19.8023Z" }), (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.8068 5.61234L5.60683 19.8023L4.19312 18.3876L18.3931 4.19763L19.8068 5.61234Z" })] }));
}
exports.CrossIcon = CrossIcon;
//# sourceMappingURL=index.js.map